<!-- template for the modal component -->
<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">

          <div class="modal-header">
            <slot name="header">
              default header
            </slot>
          </div>

          <div class="modal-body">
            <slot name="body">
              default body
            </slot>
          </div>

          <div class="modal-footer">
            <slot name="footer">

              <slot name="button">
                <button class="button-css" @click="click">
                  default button name
                </button>
              </slot>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'modal',
  data () {
    return {
      showModal: false
    }
  },
  methods: {
    click () {
      this.$emit('click')
      this.showModal = false
    }

  }
}
</script>

<style>
body {
  font-family: Microsoft JhengHei;
}
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  font-family: Microsoft JhengHei,Helvetica, Arial, sans-serif;;
  width: 550px;
  margin: 0px auto;
  /* padding: 20px 30px; */
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
}

@media screen and (min-width: 200px) and (max-width: 450px) {
  .modal-container {
    font-family: Microsoft JhengHei,Helvetica, Arial, sans-serif;;
    width: 300px;
    margin: 0px auto;
    /* padding: 20px 30px; */
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
  }
}

.modal-header h3 {
  margin-top: 0;
  /* color: #42b983; */
  background: #009a9b;
  color: #fff;
  padding: 15px;
  font-size: 21px;
  text-align: center;
}

.modal-body {
  margin: 20px 0;
  text-align: left;
  max-height: 300px;
  overflow: auto;
  height: 300px;
  padding-top: 10px;
  padding-right: 30px;
  padding-bottom: 10px;
  padding-left: 30px;
}

.button-css {
  float: center;
  /* position: absolute; */
  z-index: 9;
  left: 0;
  right: 0;
  bottom: 20px;
  margin: auto;
  padding: 15px;
  width: 280px;
  max-width: 88%;
  font-size: 18px;
  text-align: center;
  color: #fff;
  background: #2dc2c3;
  text-decoration: none;
  outline: none;
  border: none;
}
.button-css:hover {
  background: #009a9b;
}
.modal-footer {
  padding-bottom: 20px;
  text-align: center;
}
/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
